import {
  id,
  milestone,
  project,
  retrieveMilestoneError,
  zone,
} from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRetrieveMilestoneError(milestoneId) {
      const req = getState().find(
        ({ milestone }) => milestone.uuid === milestoneId,
      );

      return req ? req.error : retrieveMilestoneError;
    },
    getMilestone(milestoneId) {
      const res = getState().find(({ id }) => id === milestoneId);

      return res
        ? res.milestone
        : {
            ...milestone,
            uuid: milestoneId,
            milestone: { ...milestone, uuid: id },
            project: { ...project, uuid: id },
            zone: { ...zone, uuid: id },
          };
    },
    isMilestoneRetrievalRequestFailure(milestoneId) {
      const res = getState().find(({ id }) => id === milestoneId);

      return res ? res.request.isFailure : false;
    },
    isMilestoneRetrievalRequestPending(milestoneId) {
      const res = getState().find(({ id }) => id === milestoneId);

      return res ? res.request.isPending : false;
    },
    isMilestoneRetrievalRequestSuccess(milestoneId) {
      const res = getState().find(({ id }) => id === milestoneId);

      return res ? res.request.isSuccessful : false;
    },
    hasRetrievedMilestone(milestoneId) {
      const res = getState().find(({ id }) => id === milestoneId);

      return res ? res.request.isSuccessful || res.request.isFailure : false;
    },
  };
}

export { createSelector };
